import { createElement } from "react";
import React from "react";
import { cons, ofSeq, collect, min, empty as empty_1, filter, max, head, tail, isEmpty, ofArray, singleton, map, toArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, SearchParams, ActivityDateRange } from "../ClientTypes.fs.js";
import { compare, utcNow, year as year_1, toString } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { totalHours } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { FSharpMap__TryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { year as year_2, addSeconds, create } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { compare as compare_1, stringHash, comparePrimitives, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { map as map_2, empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { System_Double__Double_ToLocaleString, System_Int32__Int32_ToLocaleString } from "../Prelude.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { map as map_3 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi as reactApi_1 } from "../Bindings/Nivo/../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ResponsiveCalendar } from "@nivo/calendar";
import { List_distinct } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { LoadingBar, NoData } from "../Assets.fs.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";

function CalendarHeatmapChart(calendarHeatmapChartInputProps) {
    const valueToShow = calendarHeatmapChartInputProps.valueToShow;
    const year = calendarHeatmapChartInputProps.year;
    const data = calendarHeatmapChartInputProps.data;
    const properties_7 = ofArray([["data", toArray(map((d) => {
        switch (valueToShow) {
            case "Completed":
                return {
                    QueryParam: new SearchParams(12, [new ActivityDateRange(0, [d.Date])]),
                    data: d,
                    day: toString(d.Date, "D"),
                    value: d.Completed,
                };
            case "Planned":
                return {
                    QueryParam: new SearchParams(12, [new ActivityDateRange(2, [d.Date])]),
                    data: d,
                    day: toString(d.Date, "D"),
                    value: d.Planned,
                };
            case "Actual Hours":
                return {
                    QueryParam: new SearchParams(12, [new ActivityDateRange(0, [d.Date])]),
                    data: d,
                    day: toString(d.Date, "D"),
                    value: totalHours(d.ActualCompletionTime),
                };
            case "Planned Hours":
                return {
                    QueryParam: new SearchParams(12, [new ActivityDateRange(2, [d.Date])]),
                    data: d,
                    day: toString(d.Date, "D"),
                    value: totalHours(d.EstimatedCompletionTime),
                };
            default:
                return {
                    QueryParam: new SearchParams(12, [new ActivityDateRange(0, [d.Date])]),
                    data: d,
                    day: toString(d.Date, "D"),
                    value: defaultArg(map_1((v) => v.Completed, FSharpMap__TryFind(d.AttributeCount, valueToShow)), d.Completed),
                };
        }
    }, data))], ["from", create(year, 1, 1, 0, 0, 0, 0, 0)], ["to", addSeconds(create(year + 1, 1, 1, 0, 0, 0, 0, 0), -1)], ["emptyColor", "#eeeeee"], ["colors", ["#61cdbb", "#97e3d5", "#e8c1a0", "#f47560"]], ["margin", {
        top: defaultArg(0, 0),
        right: defaultArg(0, 0),
        left: defaultArg(20, 0),
        bottom: defaultArg(0, 0),
    }], ["yearSpacing", 40], ["monthBorderColor", "#000000"], ["monthBorderWidth", 2], ["daySpacing", 1], ["dayBorderWidth", 2], ["dayBorderColor", "#ffff"], ["onClick", (a) => {
        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(a.data.QueryParam), false);
    }], ["tooltip", (day_5) => {
        let elems, children;
        return createElement("div", createObj(Helpers_combineClasses("box", ofArray([["className", "tooltip"], (elems = [createElement("h5", {
            className: "subtitle is-5",
            children: day_5.day,
        }), (children = toList(delay(() => append(singleton_1(createElement("li", createObj(toList(delay(() => append(singleton_1(["key", "Completed"]), delay(() => append((valueToShow === "Completed") ? singleton_1(["className", "has-text-info"]) : empty(), delay(() => singleton_1(["children", `Actual - ${System_Int32__Int32_ToLocaleString(day_5.data.data.Completed)}`])))))))))), delay(() => append(singleton_1(createElement("li", createObj(toList(delay(() => append(singleton_1(["key", "Planned"]), delay(() => append((valueToShow === "Planned") ? singleton_1(["className", "has-text-info"]) : empty(), delay(() => singleton_1(["children", `Planned - ${System_Int32__Int32_ToLocaleString(day_5.data.data.Planned)}`])))))))))), delay(() => append(singleton_1(createElement("li", createObj(toList(delay(() => append(singleton_1(["key", "Actual Hours"]), delay(() => append((valueToShow === "Actual Hours") ? singleton_1(["className", "has-text-info"]) : empty(), delay(() => singleton_1(["children", `Actual Hours - ${System_Double__Double_ToLocaleString(totalHours(day_5.data.data.EstimatedCompletionTime))}`])))))))))), delay(() => append(singleton_1(createElement("li", createObj(toList(delay(() => append(singleton_1(["key", "Planned Hours"]), delay(() => append((valueToShow === "Planned Hours") ? singleton_1(["className", "has-text-info"]) : empty(), delay(() => singleton_1(["children", `Planned Hours - ${System_Double__Double_ToLocaleString(totalHours(day_5.data.data.EstimatedCompletionTime))}`])))))))))), delay(() => map_2((kv) => createElement("li", createObj(toList(delay(() => append(singleton_1(["key", kv[0]]), delay(() => append((valueToShow === kv[0]) ? singleton_1(["className", "has-text-info"]) : empty(), delay(() => singleton_1(["children", `${kv[0]} - ${System_Double__Double_ToLocaleString(kv[1].Completed)}`]))))))))), day_5.data.data.AttributeCount))))))))))), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    }], ["theme", {
        textColor: "#fff",
        text: {
            color: "#fff",
            fill: "#fff",
        },
        tooltip: {
            container: {
                background: "#333",
            },
        },
    }], ["legends", map_3(createObj, [ofArray([["direction", "row"], ["anchor", "bottom"], ["justify", false], ["translateX", 0], ["translateY", 0], ["itemsSpacing", 5], ["itemWidth", 60], ["itemHeight", 20]])])]]);
    return reactApi_1.createElement(ResponsiveCalendar, createObj(properties_7));
}

function CalendarHeatMapWithData(calendarHeatMapWithDataInputProps) {
    let elms_1, elms_13, elms_2, children_2, elems_4, elems_27;
    const data = calendarHeatMapWithDataInputProps.data;
    const patternInput = reactApi.useState(false);
    const optionsMenu = patternInput[0];
    let patternInput_1;
    const initial_1 = year_1(utcNow()) | 0;
    patternInput_1 = reactApi.useState(initial_1);
    const setCurrentYear = patternInput_1[1];
    const currentYear = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState("Completed");
    const setCurrentData = patternInput_2[1];
    const currentData = patternInput_2[0];
    const isCompleted = currentData === "Completed";
    const isPlanned = currentData === "Planned";
    const isActualCompletionTime = currentData === "Actual Hours";
    const isEstimatedCompletionTime = currentData === "Planned Hours";
    const dependencies = [data];
    reactApi.useEffect(() => {
        setCurrentYear(!isEmpty(data) ? (isEmpty(tail(data)) ? year_2(head(data).Date) : max(map((d) => year_2(d.Date), data), {
            Compare: comparePrimitives,
        })) : year_1(utcNow()));
    }, dependencies);
    let patternInput_3;
    const dependencies_1_1 = [data, currentYear];
    patternInput_3 = reactApi.useMemo(() => {
        const filteredData = filter((d_1) => (year_2(d_1.Date) === currentYear), data);
        const dates = map((d_2) => d_2.Date, data);
        if (isEmpty(filteredData)) {
            return [empty_1(), undefined, undefined, empty_1()];
        }
        else {
            const totalMin = min(dates, {
                Compare: compare,
            });
            const totalMax = max(dates, {
                Compare: compare,
            });
            const attributes = List_distinct(collect((d_3) => ofSeq(map_2((kv) => kv[0], d_3.AttributeCount)), data), {
                Equals: (x_4, y_3) => (x_4 === y_3),
                GetHashCode: stringHash,
            });
            return [filteredData, year_2(totalMin), year_2(totalMax), attributes];
        }
    }, dependencies_1_1);
    const minYearOpt = patternInput_3[1];
    const maxYearOpt = patternInput_3[2];
    if (isEmpty(data)) {
        return createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "project-progress"], ["className", "is-child"], ["children", (elms_1 = ofArray([createElement("div", {
            className: "message-header",
            children: reactApi.Children.toArray(["Calendar: No Data"]),
        }), createElement("div", createObj(Helpers_combineClasses("message-body", ofArray([["className", "progress-chart"], ["children", createElement("div", {
            className: "missing-data",
            children: NoData([]),
        })]]))))]), createElement("article", {
            className: "message",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))]]))));
    }
    else {
        return createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "project-progress"], ["className", "is-child"], ["children", (elms_13 = ofArray([(elms_2 = ofArray([`Calendar Heatmap: (${currentData}) : ${minYearOpt} - ${maxYearOpt}`, (children_2 = ofArray([createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => append((compare_1(currentYear, minYearOpt) <= 0) ? singleton_1(op_PlusPlus(["className", "has-text-grey"], ["className", "mr-2"])) : append(singleton_1(["onClick", (_arg) => {
            setCurrentYear(currentYear - 1);
        }]), delay(() => singleton_1(op_PlusPlus(["className", "is-clickable"], ["className", "mr-2"])))), delay(() => append(singleton_1(["title", "Previous"]), delay(() => {
            let elems_2;
            return singleton_1((elems_2 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-caret-left"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_2))]));
        }))))))))), createElement("span", createObj(ofArray([["children", currentYear], op_PlusPlus(["className", "is-size-7"], ["className", "mr-2"])]))), createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => append((compare_1(currentYear, maxYearOpt) >= 0) ? singleton_1(op_PlusPlus(["className", "has-text-grey"], ["className", "mr-2"])) : append(singleton_1(["onClick", (_arg_1) => {
            setCurrentYear(currentYear + 1);
        }]), delay(() => singleton_1(op_PlusPlus(["className", "is-clickable"], ["className", "mr-2"])))), delay(() => append(singleton_1(["title", "Next"]), delay(() => {
            let elems_3;
            return singleton_1((elems_3 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-caret-right"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
        }))))))))), createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-clickable"], ["title", "Options"], ["onClick", (_arg_2) => {
            patternInput[1](!optionsMenu);
        }], (elems_4 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-cog"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        }))]), createElement("div", {
            className: "message-header",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        })), createElement("div", createObj(Helpers_combineClasses("message-body", ofArray([["className", "progress-chart"], (elems_27 = toList(delay(() => append(singleton_1(createElement("div", {
            className: "chart",
            children: isEmpty(data) ? defaultOf() : createElement(CalendarHeatmapChart, {
                data: patternInput_3[0],
                year: currentYear,
                valueToShow: currentData,
            }),
        })), delay(() => {
            let elems_26, children_25;
            return optionsMenu ? singleton_1(createElement("div", createObj(Helpers_combineClasses("box", ofArray([["className", join(" ", ["chart-options", "ml-2"])], (elems_26 = [(children_25 = toList(delay(() => {
                let elems_9, children_7, elms_4, elms_3;
                return append(singleton_1(createElement("li", createObj(ofArray([["key", "Completed"], (elems_9 = [(children_7 = singleton((elms_4 = singleton((elms_3 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "calendar-data"], ["checked", isCompleted], ["onChange", (ev) => {
                    if (ev.target.checked) {
                        setCurrentData("Completed");
                    }
                }]]))))), "Actual"]), createElement("label", {
                    className: "label",
                    children: reactApi.Children.toArray(Array.from(elms_3)),
                }))), createElement("div", {
                    className: "control",
                    children: reactApi.Children.toArray(Array.from(elms_4)),
                }))), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(children_7)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                    let elems_13, children_11, elms_6, elms_5;
                    return append(singleton_1(createElement("li", createObj(ofArray([["key", "Planned"], (elems_13 = [(children_11 = singleton((elms_6 = singleton((elms_5 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "calendar-data"], ["checked", isPlanned], ["onChange", (ev_1) => {
                        if (ev_1.target.checked) {
                            setCurrentData("Planned");
                        }
                    }]]))))), "Planned"]), createElement("label", {
                        className: "label",
                        children: reactApi.Children.toArray(Array.from(elms_5)),
                    }))), createElement("div", {
                        className: "control",
                        children: reactApi.Children.toArray(Array.from(elms_6)),
                    }))), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(children_11)),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))), delay(() => {
                        let elems_17, children_15, elms_8, elms_7;
                        return append(singleton_1(createElement("li", createObj(ofArray([["key", "Actual Hours"], (elems_17 = [(children_15 = singleton((elms_8 = singleton((elms_7 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "calendar-data"], ["checked", isActualCompletionTime], ["onChange", (ev_2) => {
                            if (ev_2.target.checked) {
                                setCurrentData("Actual Hours");
                            }
                        }]]))))), "Actual Hours"]), createElement("label", {
                            className: "label",
                            children: reactApi.Children.toArray(Array.from(elms_7)),
                        }))), createElement("div", {
                            className: "control",
                            children: reactApi.Children.toArray(Array.from(elms_8)),
                        }))), createElement("div", {
                            className: "field",
                            children: reactApi.Children.toArray(Array.from(children_15)),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))), delay(() => {
                            let elems_21, children_19, elms_10, elms_9;
                            return append(singleton_1(createElement("li", createObj(ofArray([["key", "Planned Hours"], (elems_21 = [(children_19 = singleton((elms_10 = singleton((elms_9 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "calendar-data"], ["checked", isEstimatedCompletionTime], ["onChange", (ev_3) => {
                                if (ev_3.target.checked) {
                                    setCurrentData("Planned Hours");
                                }
                            }]]))))), "Planned Hours"]), createElement("label", {
                                className: "label",
                                children: reactApi.Children.toArray(Array.from(elms_9)),
                            }))), createElement("div", {
                                className: "control",
                                children: reactApi.Children.toArray(Array.from(elms_10)),
                            }))), createElement("div", {
                                className: "field",
                                children: reactApi.Children.toArray(Array.from(children_19)),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_21))])])))), delay(() => map((attr) => {
                                let elems_25, children_23, elms_12, elms_11;
                                return createElement("li", createObj(ofArray([["key", attr], (elems_25 = [(children_23 = singleton((elms_12 = singleton((elms_11 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "calendar-data"], ["checked", currentData === attr], ["onChange", (ev_4) => {
                                    if (ev_4.target.checked) {
                                        setCurrentData(attr);
                                    }
                                }]]))))), attr]), createElement("label", {
                                    className: "label",
                                    children: reactApi.Children.toArray(Array.from(elms_11)),
                                }))), createElement("div", {
                                    className: "control",
                                    children: reactApi.Children.toArray(Array.from(elms_12)),
                                }))), createElement("div", {
                                    className: "field",
                                    children: reactApi.Children.toArray(Array.from(children_23)),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_25))])])));
                            }, patternInput_3[3])));
                        }));
                    }));
                }));
            })), createElement("ul", {
                children: reactApi.Children.toArray(Array.from(children_25)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_26))])]))))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems_27))])]))))]), createElement("article", {
            className: "message",
            children: reactApi.Children.toArray(Array.from(elms_13)),
        }))]]))));
    }
}

export function CalendarHeatMap(calendarHeatMapInputProps) {
    let elms_1, elems_1;
    const dataOpt = calendarHeatMapInputProps.dataOpt;
    if (dataOpt == null) {
        return createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "project-progress"], ["className", "is-child"], ["children", (elms_1 = ofArray([createElement("div", {
            className: "message-header",
            children: reactApi.Children.toArray(["Calendar Heatmap: Loading..."]),
        }), createElement("div", createObj(Helpers_combineClasses("message-body", ofArray([["className", "progress-chart"], (elems_1 = [createElement("div", {
            className: "chart",
            children: LoadingBar([]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))]), createElement("article", {
            className: "message",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))]]))));
    }
    else {
        const data = dataOpt;
        return createElement(CalendarHeatMapWithData, {
            data: data,
        });
    }
}

